import mod from "-!../../../../babel-loader/lib/index.js??ref--10-0!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./EditHeatmapOrGridData.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../babel-loader/lib/index.js??ref--10-0!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./EditHeatmapOrGridData.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/EditHeatmapOrGridData.vue?vue&type=script&lang=js&
// module id = 28
// module chunks = 0